/**
 * Copyright (c) 2020 Siemens Inc.
 * Unpublished - All rights reserved
 * 
 */

const START_LICENSE = 'START_LICENSE';
const END_LICENSE = 'END_LICENSE';

/**
* Returns a pretty-formatted version of the licensing data str.
* If the data is a valid JSON, it will pretty-format it. Otherwise, it is assumed
* to be a regular licensing string, and will pretty-format that instead.
*
* @param {} str 
*/
function getPrettyStr(str) {
  try {
    return JSON.stringify(JSON.parse(str), null, 2);
  } catch (e) {
    return getPrettyLicense(str);
  }
 }

/**
 * Returns a 'pretty' license str. 'pretty means:
 * 
 * 1) not having the 'START LICENSE' and/or 'END LICENSE' portion of the license files,
 * if those two tokens are at the beginning and end of the string, respectively.
 * @param {} str 
 */
function getPrettyLicense(str) {
  let prettyLicense = str;

  if (prettyLicense.startsWith(START_LICENSE)) {
    prettyLicense = prettyLicense.substr(START_LICENSE.length);
  }

  if (prettyLicense.endsWith(END_LICENSE)) {
    prettyLicense = prettyLicense.substr(0, prettyLicense.length - END_LICENSE.length);
  }

  return prettyLicense;
}

export {
  getPrettyStr
}